angular.
module("dx.webapp.overview", [
	"digiexam.node",
	"dx.webapp.api",
	"dx.webapp.exams",
	"dx.webapp.lists",
	"dx.webapp.session",

	"dx.ui.components.localize",
]);
